import UIIconButton from 'UIComponents/button/UIIconButton';
import { DeleteIcon } from 'foundations-assets';
import { useViewerActions } from '../../hooks/useViewerActions';
import { useCallback, useContext, useMemo } from 'react';
import ConditionBoxDeletePopover from '../common/ConditionBoxDeletePopover';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import { getExactKeyPath, isLogicGroup } from '../../filterQueryFormat/logic/LogicGroup';
import { isOperator } from '../../filterQueryFormat/operator/Operator';
import { useStrategy } from '../../hooks/useStrategy';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const ViewerConditionClickableBoxDeleteButton = ({
  conditionPath,
  isFilterBranchDeleteTriggered = false,
  use = 'default'
}) => {
  const {
    internalDraftValue
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    getRequiredFields
  } = useStrategy();
  const {
    onConditionDeleteHover,
    onConditionDeleteTrigger,
    onConditionDeleteCancel,
    onConditionDeleteConfirm
  } = useViewerActions();
  const conditionToDelete = useMemo(() => {
    const condition = getExactKeyPath(conditionPath, internalDraftValue);
    let conditionFilterFamily;
    if (condition && isOperator(condition)) {
      const parentLogicGroup = getExactKeyPath(conditionPath.pop(), internalDraftValue);
      conditionFilterFamily = parentLogicGroup.filterFamily;
    } else if (condition && isLogicGroup(condition)) {
      conditionFilterFamily = condition.filterFamily;
    }
    return {
      condition,
      filterFamily: conditionFilterFamily
    };
  }, [internalDraftValue, conditionPath]);
  const disabledDeleteButtonTooltip = useMemo(() => {
    if (conditionToDelete && conditionToDelete.filterFamily && isOperator(conditionToDelete.condition)) {
      const requiredFields = getRequiredFields(conditionToDelete.filterFamily);
      if (conditionToDelete.condition.field && requiredFields.has(conditionToDelete.condition.field.name)) {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.requiredFieldDisabledButtonTooltip"
        });
      }
    }
    return undefined;
  }, [conditionToDelete, getRequiredFields]);
  const onDelete = useCallback(event => {
    event.stopPropagation();
    onConditionDeleteTrigger(conditionPath);
  }, [onConditionDeleteTrigger, conditionPath]);
  return /*#__PURE__*/_jsx(ConditionBoxDeletePopover, {
    isOpen: isFilterBranchDeleteTriggered,
    onCancel: onConditionDeleteCancel,
    onConfirm: () => onConditionDeleteConfirm(conditionPath),
    children: /*#__PURE__*/_jsx("div", {
      className: "delete-button-container",
      children: /*#__PURE__*/_jsx(UITooltip, {
        disabled: !disabledDeleteButtonTooltip,
        title: disabledDeleteButtonTooltip,
        children: use === 'hover' ? /*#__PURE__*/_jsx(UIIconButton, {
          disabled: Boolean(disabledDeleteButtonTooltip),
          "data-test-id": "delete-button",
          onClick: onDelete,
          onMouseEnter: () => onConditionDeleteHover(conditionPath),
          onMouseLeave: () => onConditionDeleteHover(undefined),
          size: "xs",
          children: /*#__PURE__*/_jsx(DeleteIcon, {})
        }) : /*#__PURE__*/_jsx(UIIconButton, {
          disabled: Boolean(disabledDeleteButtonTooltip),
          "data-test-id": "delete-button",
          onClick: onDelete,
          onMouseEnter: () => onConditionDeleteHover(conditionPath),
          onMouseLeave: () => onConditionDeleteHover(undefined),
          className: "p-all-0",
          size: "sm",
          use: "transparent",
          children: /*#__PURE__*/_jsx(DeleteIcon, {})
        })
      })
    })
  });
};
export default ViewerConditionClickableBoxDeleteButton;